import React from 'react'
import PropTypes from 'prop-types'

import CountdownTimer from '../../CountdownTimer'

import { StyledWrapper, StyledSubTitle } from './styles'

const ChangeReportType = ({ onConfirm, onCancel }) => (
  <StyledWrapper>
    <StyledSubTitle>
      <p>Are you sure you want to change report type?</p>
      After uploading conversions, you will not be able to change report type
      again until you delete all conversions that were uploaded.
    </StyledSubTitle>

    <CountdownTimer onConfirm={onConfirm} onCancel={onCancel} />
  </StyledWrapper>
)

ChangeReportType.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default ChangeReportType
